export const swConfig = {
    onUpdate: (registration) => {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    },
    onSuccess: (registration) => {
        console.info("service worker on success state");
        console.log(registration);
    },
};
